import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "preloader-area",
  id: "preloader"
}
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<div class=\"loader\"><div class=\"waviy\"><span>G</span><span>U</span><span>A</span><span>C</span><span>|</span><span>N</span><span>|</span><span>G</span><span>r</span><span>i</span><span>l</span><span>l</span></div><div class=\"tagline\"><span>H</span><span>a</span><span>l</span><span>a</span><span>l</span><span> </span><span>M</span><span>e</span><span>x</span><span>i</span><span>c</span><span>a</span><span>n</span></div></div>", 1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_ctx.isLoading)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, _hoisted_3))
    : _createCommentVNode("", true)
}